var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFeather(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M21.072 2.927C18.385.242 14.126.143 10.232 4.032L6.548 7.713c-2.598 2.595-3.025 6.481-2.735 9.074l7.667-7.66a.69.69 0 01.974.973L1.302 21.24a1.033 1.033 0 001.46 1.458l2.84-2.837c2.248.675 7.386.78 10.607-2.36h-4.22l6.342-2.112c2.148-2.146 1.563-1.555 1.99-2.014h-4.202l5.652-1.882c1.953-3.2 1.474-6.395-.699-8.566z"
  }))));
}

export default SvgFeather;